export default {
  title: `Hoppla!
          <br /> Etwas stimmt nicht`,
  description: `<p>Etwas ist schief gelaufen.</p>
                <p>
                  Bitte versuchen Sie es später noch einmal. Wenn das Problem weiterhin besteht, kontaktieren Sie unser
                  Support-Team für Unterstützung.
                </p>`,
};
